
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { authKey, GET_CONSIGNMENT_ISSUE_LIST } from '../../../common/URLs';
import Moment from 'moment';
import jwt from 'jwt-decode';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Container, Card, CardContent, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, Button, Tooltip, IconButton } from '@mui/material';
import { ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function ConsignmentIssueList() {

    const navigate = useNavigate();
    const [consignmentIssueList, setConsignmentIssueList] = useState();

    const onViewDetails = (row) => {
        navigate('./onHoldInvoiceList', {
            state: { selectedRow: row }
        });
    }

    useEffect(() => {
        getConsignmentIssueList();

    }, []);

    const getConsignmentIssueList = (e) => {
        loaderService.showLoader()
        apiClient
            .post(GET_CONSIGNMENT_ISSUE_LIST,
                {
                    "issueNumberStatus": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setConsignmentIssueList(response.data.consignmentIssueList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const columns = [
        { field: 'stakeholderType', headerName: 'Stakeholder', width: 160 },
        { field: 'stakeholderUrn', headerName: 'URN', width: 150 },
        { field: 'consignmentNo', headerName: 'Consignment No', width: 150 },
        { field: 'issueNumber', headerName: 'Issue Number', width: 160 },
        { field: 'issueNumberStatus', headerName: 'Status', width: 150 },
        { field: 'pickupNetWeight', headerName: 'Pickup Weight', width: 150 },
        { field: 'destinationNetWeight', headerName: 'Destination Weight', width: 150 },
        { field: 'consignmentStatus', headerName: 'Consignment Status', width: 150 },
        {
            field: 'Action', width: 120,
            renderCell: (params) => {
                return (
                    <Tooltip title="View">
                    <IconButton
                        variant="contained"
                        color="primary"
                        onClick={() => onViewDetails(params.row)}
                    >
                        <ViewIcon />
                    </IconButton>
                    </Tooltip>
                );
            }
        },
    ];


    return (
        <>
            <Container maxWidth="xxl">
                <Typography variant="h5" gutterBottom>
                    Consignment Issue List
                </Typography>
                <Card>
                    <CardContent>
                        <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                                    {
                                        consignmentIssueList &&
                                        <DataGrid rows={consignmentIssueList}
                                            columns={columns}
                                            pageSize={10}
                                            getRowId={(row) => row.issueNumber}
                                            components={{ Toolbar: QuickSearchToolbar }}
                                        />
                                    }

                                </Box>
                    </CardContent>
                </Card>
            </Container>
        </>
    );
}
export default ConsignmentIssueList;
